import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconPorosityMapSizeS from './IconPorosityMap_size_s';

const props: CreateIconArguments = {
  l: IconPorosityMapSizeS,
  m: IconPorosityMapSizeS,
  s: IconPorosityMapSizeS,
  xs: IconPorosityMapSizeS,
  name: 'IconPorosityMap',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
